import Label from "./Label.mjs";
export * from "./Label.mjs";
var lib_default = Label;
export {
  lib_default as default
};
